var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 672.249,
    height: 510,
    viewBox: "0 0 672.249 510",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2258",
    "data-name": "Grupo 2258",
    transform: "translate(-200.971 -348.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2023",
    "data-name": "Grupo 2023",
    transform: "translate(468.938 381.277)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2022",
    "data-name": "Grupo 2022",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_940",
    "data-name": "Caminho 940",
    d: "M993.2,448.172l12.684-4.685v-.217l.294.108.739-.273v.546l12.687,4.678s14.065,409.474,13.42,439.526S1005.6,915.3,1005.6,915.3v-.114c-4.921.112-25.829-.972-26.413-27.481C978.524,857.655,993.2,448.172,993.2,448.172Z",
    transform: "translate(-979.165 -443.105)",
    fill: "#49263e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2025",
    "data-name": "Grupo 2025",
    transform: "translate(509.654 401.152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2024",
    "data-name": "Grupo 2024"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_941",
    "data-name": "Caminho 941",
    d: "M1109.744,925.728l1.622-.06-12.337-424.844-1.622.06Z",
    transform: "translate(-1097.406 -500.824)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2027",
    "data-name": "Grupo 2027",
    transform: "translate(474.473 359.551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2026",
    "data-name": "Grupo 2026",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_67",
    "data-name": "Elipse 67",
    cx: 17.072,
    cy: 17.072,
    r: 17.072,
    transform: "translate(0 11.891) rotate(-20.381)",
    fill: "#85baf9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2029",
    "data-name": "Grupo 2029",
    transform: "translate(487.85 348.97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2028",
    "data-name": "Grupo 2028",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_942",
    "data-name": "Caminho 942",
    d: "M1034.086,357.851a8.565,8.565,0,1,0,8.563-8.568A8.565,8.565,0,0,0,1034.086,357.851Z",
    transform: "translate(-1034.086 -349.283)",
    fill: "#85baf9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2031",
    "data-name": "Grupo 2031",
    transform: "translate(477.203 391.673)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2030",
    "data-name": "Grupo 2030",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_943",
    "data-name": "Caminho 943",
    d: "M1007.931,473.3l28.551-.008v.019c.125-.01.25-.019.378-.019a4.766,4.766,0,1,1,0,9.531c-.147,0-.291-.009-.434-.022l-28.06.008c-.143.013-.288.022-.434.022a4.766,4.766,0,1,1,0-9.531Z",
    transform: "translate(-1003.167 -473.295)",
    fill: "#a4d2ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2033",
    "data-name": "Grupo 2033",
    transform: "translate(482.345 360.936)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2032",
    "data-name": "Grupo 2032"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_944",
    "data-name": "Caminho 944",
    d: "M1021.588,384.04l20.9-.006v.014c.092-.007.183-.014.276-.014a3.489,3.489,0,1,1,0,6.978c-.107,0-.213-.006-.318-.016l-20.543.006c-.1.009-.21.016-.317.016a3.489,3.489,0,1,1,0-6.978Z",
    transform: "translate(-1018.1 -384.034)",
    fill: "#a4d2ff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2035",
    "data-name": "Grupo 2035",
    transform: "translate(470.358 505.215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2034",
    "data-name": "Grupo 2034"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_945",
    "data-name": "Caminho 945",
    d: "M984.909,1019.916l6.763-216.825-1.621-.063-6.763,216.825Z",
    transform: "translate(-983.288 -803.028)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2037",
    "data-name": "Grupo 2037",
    transform: "translate(501.882 735.16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2036",
    "data-name": "Grupo 2036",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_663",
    "data-name": "Ret\\xE2ngulo 663",
    width: 1.623,
    height: 12.368,
    transform: "matrix(0.903, -0.429, 0.429, 0.903, 0, 0.696)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2039",
    "data-name": "Grupo 2039",
    transform: "translate(498.453 745.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2038",
    "data-name": "Grupo 2038",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_664",
    "data-name": "Ret\\xE2ngulo 664",
    width: 1.623,
    height: 12.368,
    transform: "matrix(0.903, -0.429, 0.429, 0.903, 0, 0.696)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2041",
    "data-name": "Grupo 2041",
    transform: "translate(481.515 400.263)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2040",
    "data-name": "Grupo 2040",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_665",
    "data-name": "Ret\\xE2ngulo 665",
    width: 30.485,
    height: 1.623,
    transform: "matrix(1, -0.004, 0.004, 1, 0, 0.117)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2043",
    "data-name": "Grupo 2043",
    transform: "translate(481.512 390.807)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2042",
    "data-name": "Grupo 2042",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_666",
    "data-name": "Ret\\xE2ngulo 666",
    width: 30.485,
    height: 1.623,
    transform: "translate(0 0.117) rotate(-0.22)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2045",
    "data-name": "Grupo 2045",
    transform: "translate(482.996 367.09)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2044",
    "data-name": "Grupo 2044",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_667",
    "data-name": "Ret\\xE2ngulo 667",
    width: 26.856,
    height: 1.623
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2047",
    "data-name": "Grupo 2047",
    transform: "translate(346.833 824.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2046",
    "data-name": "Grupo 2046"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_946",
    "data-name": "Caminho 946",
    d: "M624.565,1764.771c10.507-18.794,73.031-33.249,148.6-33.271s138.1,14.4,148.619,33.183Z",
    transform: "translate(-624.565 -1731.5)",
    fill: "#5295d8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2049",
    "data-name": "Grupo 2049",
    transform: "translate(346.833 826.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2048",
    "data-name": "Grupo 2048"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_947",
    "data-name": "Caminho 947",
    d: "M624.565,1767c10.507-18.793,72-32.1,112.056-32.1-18.47,3.731-41.071,2.937-96.786,32.078Z",
    transform: "translate(-624.565 -1734.901)",
    fill: "#0a4677"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2051",
    "data-name": "Grupo 2051",
    transform: "translate(515.232 825.175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2050",
    "data-name": "Grupo 2050"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_948",
    "data-name": "Caminho 948",
    d: "M1191.526,1754.983c-51.255-15.865-119.822-27.8-44.594-20.639,74.48,7.093,84.977,12.021,95.495,30.808C1242.427,1765.152,1204.381,1758.962,1191.526,1754.983Z",
    transform: "translate(-1113.607 -1732.216)",
    fill: "#0a4677"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2062",
    "data-name": "Grupo 2062",
    transform: "translate(316.082 348.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2053",
    "data-name": "Grupo 2053"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2052",
    "data-name": "Grupo 2052"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_949",
    "data-name": "Caminho 949",
    d: "M538.141,603.561a15.5,15.5,0,0,0,8.266,6.576c19.575,6.7,38.984.87,55.611-11.717,38.006-28.761,26.964-96.47,53.211-112.158,13.639-8.149,19.751-7.349,28.21-6.242,8.945,1.17,21,2.745,36.982-6.368a31.15,31.15,0,0,0,4.808-3.134c14.788-10.943,18.215-22.607,20.755-31.263,2.4-8.187,4.138-14.1,17.1-23.29,24.948-17.679,82.44,19.755,124.093-3.4,18.229-10.131,31.394-25.535,33.17-46.148,1.109-12.881-13.355-22.471-24.865-14.969a16.838,16.838,0,0,0-7.409,12.294c-.586,5.861-4.212,13.573-16.646,20.493-28.268,15.715-86.759-23.265-127.088,5.289-22.148,15.7-26.372,30.1-29.456,40.607-2.091,7.125-3.007,10.242-9.7,14.89-6.954,4.245-10.174,3.824-17.538,2.861-10.862-1.422-25.737-3.368-49.043,10.557-42.389,25.361-30.354,94.618-56.144,114.137-10.945,8.276-19.256,8.76-24.856,7.144a16,16,0,0,0-19.461,23.845ZM898.906,368.316a6.342,6.342,0,1,1,8.776,1.85A6.342,6.342,0,0,1,898.906,368.316ZM546.921,597.731a6.342,6.342,0,1,1,8.776,1.85A6.342,6.342,0,0,1,546.921,597.731Z",
    transform: "translate(-535.261 -348.805)",
    fill: "#5295d8"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2055",
    "data-name": "Grupo 2055",
    transform: "translate(169.474 96.122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2054",
    "data-name": "Grupo 2054",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_68",
    "data-name": "Elipse 68",
    cx: 7.691,
    cy: 7.691,
    r: 7.691,
    transform: "translate(0 9.911) rotate(-40.115)",
    fill: "#85baf9"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2057",
    "data-name": "Grupo 2057",
    transform: "translate(129.89 61.755)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2056",
    "data-name": "Grupo 2056"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_950",
    "data-name": "Caminho 950",
    d: "M970.233,590.723q2.137-1.393,4.278-3.094c13.807-11.008,16.281-19.827,18.673-28.356,1.515-5.4,2.947-10.5,7.307-15.88,10.916-13.458,23.322-13.624,23.446-13.624l0-1.623c-.537,0-13.276.13-24.709,14.224-4.571,5.636-6.047,10.9-7.609,16.464-2.323,8.28-4.725,16.843-18.123,27.525-15.587,12.427-31.246,11.329-43.829,10.446-6.948-.487-12.949-.908-17.2,1.246l.734,1.448c3.851-1.951,9.644-1.545,16.353-1.075C941.279,599.247,955.614,600.251,970.233,590.723Z",
    transform: "translate(-912.471 -528.147)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2059",
    "data-name": "Grupo 2059",
    transform: "translate(49.918 104.057)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2058",
    "data-name": "Grupo 2058"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_951",
    "data-name": "Caminho 951",
    d: "M681.342,768.319c8.917-8.43,10.378-15.305,13.581-30.37,1.741-8.187,4.124-19.4,8.6-34.763,6.4-21.945,16.75-34.545,24.308-41.251,8.183-7.261,14.943-9.369,15.01-9.389l-.469-1.554c-.286.086-7.1,2.2-15.538,9.658-7.745,6.849-18.346,19.709-24.869,42.081-4.5,15.421-6.887,26.668-8.633,34.88-3.224,15.167-4.558,21.445-13.108,29.528Z",
    transform: "translate(-680.227 -650.993)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2061",
    "data-name": "Grupo 2061",
    transform: "translate(317.588 34.96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2060",
    "data-name": "Grupo 2060"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_952",
    "data-name": "Caminho 952",
    d: "M1498.867,475.522a66.493,66.493,0,0,0,8.707-6.752c9.666-8.888,13.311-17.452,13.462-17.812l-1.5-.626c-.036.085-3.692,8.649-13.123,17.3-8.7,7.975-24.23,17.664-48.858,18.531l.057,1.622C1476.035,487.137,1489.488,481.635,1498.867,475.522Z",
    transform: "translate(-1457.557 -450.332)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_953",
    "data-name": "Caminho 953",
    d: "M1545.574,1736.3l.037-.484a2.008,2.008,0,0,1,2.155-1.85s49.811-17.118,103.435-13.027,103.611,28.821,103.611,28.821l-.343,4.489s-49.133-23.848-103.612-28.82c-40.774-3.722-103.435,13.027-103.435,13.027A2.008,2.008,0,0,1,1545.574,1736.3Z",
    transform: "translate(-881.592 -899.235)",
    fill: "#213748"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2256",
    "data-name": "Grupo 2256",
    transform: "translate(200.971 593.329)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ret\\xE2ngulo_668",
    "data-name": "Ret\\xE2ngulo 668",
    d: "M0,0H4.5a0,0,0,0,1,0,0V207.4a2.251,2.251,0,0,1-2.251,2.251h0A2.251,2.251,0,0,1,0,207.4V0A0,0,0,0,1,0,0Z",
    transform: "translate(133.688 209.656) rotate(-180)",
    fill: "#213748"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2255",
    "data-name": "Grupo 2255",
    transform: "translate(11.496 45.738)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2252",
    "data-name": "Grupo 2252"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2069",
    "data-name": "Grupo 2069",
    transform: "translate(106.041 117.072)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2068",
    "data-name": "Grupo 2068"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2067",
    "data-name": "Grupo 2067"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2066",
    "data-name": "Grupo 2066"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2065",
    "data-name": "Grupo 2065"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2064",
    "data-name": "Grupo 2064"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2063",
    "data-name": "Grupo 2063"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_954",
    "data-name": "Caminho 954",
    d: "M548.978,1532.388c3.683-.261,7.966-.566,9.018-.647,1.931-.149,8.579,1.5,10.675,3.04,3.8,2.784,1.588,3.129,1.588,3.129,3.679,3.262.02,3.385.02,3.385,3.552,2.633.13,3.416.13,3.416,1.761,1.609,1.455,2.455.894,2.881a1.634,1.634,0,0,1-1.448.242c-.914-.268-2.918-.865-5.013-1.526h0a171.9,171.9,0,0,0-17.974-.563l-4.561-.4S548.93,1532.336,548.978,1532.388Z",
    transform: "translate(-542.308 -1531.731)",
    fill: "#ff9166"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2070",
    "data-name": "Grupo 2070",
    transform: "translate(62.582 54.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_955",
    "data-name": "Caminho 955",
    d: "M416.853,1350.034s13.173,6.3,24.867,56.244l30.164,6.22v7.212l-37.127-2.312s-18.658-9.741-18.658-9.865S416.853,1350.034,416.853,1350.034Z",
    transform: "translate(-416.099 -1350.034)",
    fill: "#b5d6fb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2072",
    "data-name": "Grupo 2072",
    transform: "translate(1.805 41.786)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2071",
    "data-name": "Grupo 2071"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_956",
    "data-name": "Caminho 956",
    d: "M239.651,1342.047a24.391,24.391,0,0,1,17.019-24.881c4.4-1.387,8.923-2.693,12.728-3.545,12.017-2.69,20.933,5.491,31.73,12.194,7.042,4.372,21,98.833,21,98.833s-14.887-2.69-34.617,3.049-33.1,16.322-35.742,15.246-10.893-8.071-10.355-43.945C241.724,1378.549,240.64,1356.891,239.651,1342.047Z",
    transform: "translate(-239.597 -1313.095)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2074",
    "data-name": "Grupo 2074",
    transform: "translate(6.642 85.18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2073",
    "data-name": "Grupo 2073"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_957",
    "data-name": "Caminho 957",
    d: "M253.677,1458.666s24.932,26.008,30.492,27.084,76.231,1.256,76.231,1.256V1474.45l-64.751-9.147-16.681-26.187S252.6,1439.115,253.677,1458.666Z",
    transform: "translate(-253.645 -1439.115)",
    fill: "#fe9f73"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2195",
    "data-name": "Grupo 2195",
    transform: "translate(28.584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2084",
    "data-name": "Grupo 2084",
    transform: "translate(0.367 6.915)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2083",
    "data-name": "Grupo 2083"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2082",
    "data-name": "Grupo 2082"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2081",
    "data-name": "Grupo 2081"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2080",
    "data-name": "Grupo 2080"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2079",
    "data-name": "Grupo 2079"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2078",
    "data-name": "Grupo 2078"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2077",
    "data-name": "Grupo 2077"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2076",
    "data-name": "Grupo 2076"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2075",
    "data-name": "Grupo 2075"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_958",
    "data-name": "Caminho 958",
    d: "M343.171,1237.1l2.683-16.81-19.53-8.458-3.74,19.28-.625,5.03s-3.658,11.929-3.524,14.135,3.143,4.984,8.826,5.891a15.717,15.717,0,0,0,4.81.024c2.843-.425,4.739.757,4.843-2.116l.5-11.34C342.5,1242.816,343.171,1237.1,343.171,1237.1Z",
    transform: "translate(-318.431 -1211.828)",
    fill: "#fe9f73"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2094",
    "data-name": "Grupo 2094",
    transform: "translate(12.601 19.882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2093",
    "data-name": "Grupo 2093"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2092",
    "data-name": "Grupo 2092"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2091",
    "data-name": "Grupo 2091"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2090",
    "data-name": "Grupo 2090"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2089",
    "data-name": "Grupo 2089"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2088",
    "data-name": "Grupo 2088"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2087",
    "data-name": "Grupo 2087"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2086",
    "data-name": "Grupo 2086"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2085",
    "data-name": "Grupo 2085"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_959",
    "data-name": "Caminho 959",
    d: "M354.107,1250.417a.239.239,0,0,0,.188,0c.162-.069,4-1.647,5.606,1.382a.24.24,0,1,0,.424-.224c-1.813-3.419-6.173-1.618-6.216-1.6a.24.24,0,0,0,0,.441Z",
    transform: "translate(-353.962 -1249.486)",
    fill: "#49263e"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2104",
    "data-name": "Grupo 2104",
    transform: "translate(22.662 20.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2103",
    "data-name": "Grupo 2103"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2102",
    "data-name": "Grupo 2102"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2101",
    "data-name": "Grupo 2101"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2100",
    "data-name": "Grupo 2100"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2099",
    "data-name": "Grupo 2099"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2098",
    "data-name": "Grupo 2098"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2097",
    "data-name": "Grupo 2097"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2096",
    "data-name": "Grupo 2096"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2095",
    "data-name": "Grupo 2095"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_960",
    "data-name": "Caminho 960",
    d: "M383.458,1252.588a.236.236,0,0,0,.145-.084c.017-.021,1.738-2.1,3.02-1.335a.24.24,0,1,0,.245-.412c-1.636-.974-3.555,1.344-3.636,1.443a.24.24,0,0,0,.227.388Z",
    transform: "translate(-383.177 -1250.518)",
    fill: "#49263e"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2114",
    "data-name": "Grupo 2114",
    transform: "translate(15.935 22.477)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2113",
    "data-name": "Grupo 2113"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2112",
    "data-name": "Grupo 2112"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2111",
    "data-name": "Grupo 2111"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2110",
    "data-name": "Grupo 2110"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2109",
    "data-name": "Grupo 2109"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2108",
    "data-name": "Grupo 2108"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2107",
    "data-name": "Grupo 2107"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2106",
    "data-name": "Grupo 2106"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2105",
    "data-name": "Grupo 2105"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_961",
    "data-name": "Caminho 961",
    d: "M364.248,1258.451a.719.719,0,1,0-.6-.824A.719.719,0,0,0,364.248,1258.451Z",
    transform: "translate(-363.642 -1257.021)"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2124",
    "data-name": "Grupo 2124",
    transform: "translate(23.598 22.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2123",
    "data-name": "Grupo 2123"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2122",
    "data-name": "Grupo 2122"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2121",
    "data-name": "Grupo 2121"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2120",
    "data-name": "Grupo 2120"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2119",
    "data-name": "Grupo 2119"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2118",
    "data-name": "Grupo 2118"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2117",
    "data-name": "Grupo 2117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2116",
    "data-name": "Grupo 2116"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2115",
    "data-name": "Grupo 2115"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_962",
    "data-name": "Caminho 962",
    d: "M386.5,1259.888a.719.719,0,1,0-.6-.824A.719.719,0,0,0,386.5,1259.888Z",
    transform: "translate(-385.897 -1258.458)"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2134",
    "data-name": "Grupo 2134",
    transform: "translate(8.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2133",
    "data-name": "Grupo 2133"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2132",
    "data-name": "Grupo 2132"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2131",
    "data-name": "Grupo 2131"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2130",
    "data-name": "Grupo 2130"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2129",
    "data-name": "Grupo 2129"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2128",
    "data-name": "Grupo 2128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2127",
    "data-name": "Grupo 2127"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2126",
    "data-name": "Grupo 2126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2125",
    "data-name": "Grupo 2125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_963",
    "data-name": "Caminho 963",
    d: "M345.013,1205.945s11.265,6.581,18.3,2.038,5.567-7.5,4.2-10.551c-.672-1.506-4.475-4.959-10.053-3.477-3.045.809-4.546-3.294-8.163-1.929s-8.05,4.022-7.82,5.389.462,2.285.462,2.285Z",
    transform: "translate(-341.474 -1191.746)",
    fill: "#33192c"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2144",
    "data-name": "Grupo 2144",
    transform: "translate(0 5.515)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2143",
    "data-name": "Grupo 2143"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2142",
    "data-name": "Grupo 2142"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2141",
    "data-name": "Grupo 2141"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2140",
    "data-name": "Grupo 2140"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2139",
    "data-name": "Grupo 2139"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2138",
    "data-name": "Grupo 2138"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2137",
    "data-name": "Grupo 2137"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2136",
    "data-name": "Grupo 2136"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2135",
    "data-name": "Grupo 2135"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_964",
    "data-name": "Caminho 964",
    d: "M322.617,1233.811l4.793-17.148-1.474-7.366.821-1.424s-5.424-1.135-7.789,3.883-.753,8.1-.951,9.678S315.067,1233.415,322.617,1233.811Z",
    transform: "translate(-317.366 -1207.762)",
    fill: "#33192c"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2154",
    "data-name": "Grupo 2154",
    transform: "translate(2.959 17.131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2153",
    "data-name": "Grupo 2153"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2152",
    "data-name": "Grupo 2152"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2151",
    "data-name": "Grupo 2151"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2150",
    "data-name": "Grupo 2150"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2149",
    "data-name": "Grupo 2149"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2148",
    "data-name": "Grupo 2148"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2147",
    "data-name": "Grupo 2147"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2146",
    "data-name": "Grupo 2146"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2145",
    "data-name": "Grupo 2145"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_965",
    "data-name": "Caminho 965",
    d: "M329.6,1250.073a4.316,4.316,0,1,0-3.582-4.942A4.316,4.316,0,0,0,329.6,1250.073Z",
    transform: "translate(-325.961 -1241.495)",
    fill: "#fe9f73"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2164",
    "data-name": "Grupo 2164",
    transform: "translate(5.068 19.131)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2163",
    "data-name": "Grupo 2163"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2162",
    "data-name": "Grupo 2162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2161",
    "data-name": "Grupo 2161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2160",
    "data-name": "Grupo 2160"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2159",
    "data-name": "Grupo 2159"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2158",
    "data-name": "Grupo 2158"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2157",
    "data-name": "Grupo 2157"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2156",
    "data-name": "Grupo 2156"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2155",
    "data-name": "Grupo 2155"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_966",
    "data-name": "Caminho 966",
    d: "M335.384,1249.609l.254.348-.038-.429a2.332,2.332,0,0,0-.839-1.726,2.909,2.909,0,0,0-2.057-.47.12.12,0,0,0,.039.237,2.705,2.705,0,0,1,1.872.424,1.947,1.947,0,0,1,.693,1.187,2.028,2.028,0,0,0-2.225-.435,1.689,1.689,0,0,0-.983,1.84,1.8,1.8,0,0,0,1.459,1.6l.025,0a.12.12,0,0,0,.036-.237l-.024,0a1.546,1.546,0,0,1-1.258-1.391,1.466,1.466,0,0,1,.838-1.588A1.878,1.878,0,0,1,335.384,1249.609Z",
    transform: "translate(-332.083 -1247.303)",
    fill: "#f07162"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2174",
    "data-name": "Grupo 2174",
    transform: "translate(8.562 31.154)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2173",
    "data-name": "Grupo 2173"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2172",
    "data-name": "Grupo 2172"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2171",
    "data-name": "Grupo 2171"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2170",
    "data-name": "Grupo 2170"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2169",
    "data-name": "Grupo 2169"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2168",
    "data-name": "Grupo 2168"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2167",
    "data-name": "Grupo 2167"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2166",
    "data-name": "Grupo 2166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2165",
    "data-name": "Grupo 2165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_967",
    "data-name": "Caminho 967",
    d: "M352.812,1294.586l.208-5.7s-7.951.318-10.756-6.667C342.263,1282.218,341.079,1291.782,352.812,1294.586Z",
    transform: "translate(-342.23 -1282.218)",
    fill: "#f07162"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2183",
    "data-name": "Grupo 2183",
    transform: "translate(7.626 14.416)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2182",
    "data-name": "Grupo 2182"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2181",
    "data-name": "Grupo 2181"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2180",
    "data-name": "Grupo 2180"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2179",
    "data-name": "Grupo 2179"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2178",
    "data-name": "Grupo 2178"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2177",
    "data-name": "Grupo 2177"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2176",
    "data-name": "Grupo 2176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2175",
    "data-name": "Grupo 2175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_968",
    "data-name": "Caminho 968",
    d: "M350.353,1259.665c7.624.8,7.892-10.829,7.892-10.829-1.509-1.365-14.78-1.595-15.594-2.156-.576-.4-.055-7.221.119-9.757a5.47,5.47,0,0,0-.84-3.312l-.83,2.97-1.555,10.443C339.382,1252.177,339.444,1258.517,350.353,1259.665Z",
    transform: "translate(-339.514 -1233.611)",
    fill: "#33192c"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2193",
    "data-name": "Grupo 2193",
    transform: "translate(19.004 22.037)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2192",
    "data-name": "Grupo 2192"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2191",
    "data-name": "Grupo 2191"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2190",
    "data-name": "Grupo 2190"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2189",
    "data-name": "Grupo 2189"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2188",
    "data-name": "Grupo 2188"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2187",
    "data-name": "Grupo 2187"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2186",
    "data-name": "Grupo 2186"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2185",
    "data-name": "Grupo 2185"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2184",
    "data-name": "Grupo 2184"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_969",
    "data-name": "Caminho 969",
    d: "M372.558,1262.108a.12.12,0,0,0,.1.1.122.122,0,0,0,.038,0l2.695-.437.146-5.9a.118.118,0,0,0-.117-.122.12.12,0,0,0-.123.117l-.142,5.7-2.5.406A.12.12,0,0,0,372.558,1262.108Z",
    transform: "translate(-372.556 -1255.743)",
    fill: "#f07162"
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2194",
    "data-name": "Grupo 2194",
    transform: "translate(16.689 29.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_970",
    "data-name": "Caminho 970",
    d: "M370.158,1279.664l.224-.175c-.045-.059-1.154-1.427-4.549-.494l.076.275C369.1,1278.393,370.148,1279.651,370.158,1279.664Z",
    transform: "translate(-365.833 -1278.67)",
    fill: "#f07162"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2218",
    "data-name": "Grupo 2218",
    transform: "translate(106.041 119.727)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2202",
    "data-name": "Grupo 2202"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2201",
    "data-name": "Grupo 2201"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2200",
    "data-name": "Grupo 2200"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2199",
    "data-name": "Grupo 2199"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2198",
    "data-name": "Grupo 2198"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2197",
    "data-name": "Grupo 2197"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2196",
    "data-name": "Grupo 2196"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_971",
    "data-name": "Caminho 971",
    d: "M548.978,1540.1c3.683-.261,7.966-.566,9.018-.647,1.931-.149,8.579,1.5,10.675,3.039,3.8,2.784,1.588,3.129,1.588,3.129,3.679,3.262.02,3.386.02,3.386,3.552,2.633.13,3.416.13,3.416,1.761,1.609,1.455,2.455.894,2.881a1.633,1.633,0,0,1-1.448.242c-.914-.268-2.918-.865-5.013-1.526h0a172.028,172.028,0,0,0-17.974-.563l-4.561-.4S548.93,1540.045,548.978,1540.1Z",
    transform: "translate(-542.308 -1539.441)",
    fill: "#fe9f73"
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2217",
    "data-name": "Grupo 2217",
    transform: "translate(23.605 10.769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2216",
    "data-name": "Grupo 2216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2215",
    "data-name": "Grupo 2215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2214",
    "data-name": "Grupo 2214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2213",
    "data-name": "Grupo 2213"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2212",
    "data-name": "Grupo 2212"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2211",
    "data-name": "Grupo 2211"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2210",
    "data-name": "Grupo 2210"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2209",
    "data-name": "Grupo 2209"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2208",
    "data-name": "Grupo 2208"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2207",
    "data-name": "Grupo 2207"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2206",
    "data-name": "Grupo 2206"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2205",
    "data-name": "Grupo 2205"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2204",
    "data-name": "Grupo 2204"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2203",
    "data-name": "Grupo 2203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_972",
    "data-name": "Caminho 972",
    d: "M611.089,1570.716a.233.233,0,0,0-.069.455,28.642,28.642,0,0,1,4.219,1.958.233.233,0,0,0,.23-.405,28.613,28.613,0,0,0-4.308-2A.227.227,0,0,0,611.089,1570.716Z",
    transform: "translate(-610.857 -1570.716)",
    fill: "#f07162"
  }))))))))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2220",
    "data-name": "Grupo 2220",
    transform: "translate(0 132.036)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2219",
    "data-name": "Grupo 2219"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_669",
    "data-name": "Ret\\xE2ngulo 669",
    width: 229.861,
    height: 6.894,
    fill: "#49263e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2223",
    "data-name": "Grupo 2223",
    transform: "translate(44.383 52.419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2222",
    "data-name": "Grupo 2222"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2221",
    "data-name": "Grupo 2221"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_973",
    "data-name": "Caminho 973",
    d: "M379.939,1405.225l-9.117-1.414-7.574-59.379,2.508-.46Z",
    transform: "translate(-363.248 -1343.973)",
    fill: "#49263e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2229",
    "data-name": "Grupo 2229",
    transform: "translate(42.502 48.748)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2228",
    "data-name": "Grupo 2228"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2227",
    "data-name": "Grupo 2227"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2226",
    "data-name": "Grupo 2226"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2225",
    "data-name": "Grupo 2225"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2224",
    "data-name": "Grupo 2224"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_974",
    "data-name": "Caminho 974",
    d: "M358.29,1337.531l1.646,1.54,2.557-.549.123-3.754-2.52-1.454-2.311.854Z",
    transform: "translate(-357.786 -1333.313)",
    fill: "#49263e"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2231",
    "data-name": "Grupo 2231",
    transform: "translate(25.354 36.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2230",
    "data-name": "Grupo 2230"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_975",
    "data-name": "Caminho 975",
    d: "M313.707,1296.295l13.842,10.429,2.894-4.834,3.442,5.134-2.693,7.776-3.709-4.589-3.99,6.132-3.238-1.492a29.1,29.1,0,0,1-12.27-10.641h0Z",
    transform: "translate(-307.985 -1296.295)",
    fill: "#b5d6fb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2232",
    "data-name": "Grupo 2232",
    transform: "translate(5.459 82.624)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_976",
    "data-name": "Caminho 976",
    d: "M359.33,1467.311v13.7H283.662s-9.64.414-10.168,0-23.284-27.835-23.284-27.835l2.827-15.972,27.717-5.513,14.187,25.383Z",
    transform: "translate(-250.21 -1431.691)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2233",
    "data-name": "Grupo 2233",
    transform: "translate(35.932 82.562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_977",
    "data-name": "Caminho 977",
    d: "M417.242,1480.986h.636v-13.972l-64.711-10.347-13.905-25.155-.557.307,14.055,25.427.153.025,64.328,10.286Z",
    transform: "translate(-338.706 -1431.512)",
    fill: "#1d1d1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2234",
    "data-name": "Grupo 2234",
    transform: "translate(2.028 78.281)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_978",
    "data-name": "Caminho 978",
    d: "M278.888,1473.143l.147-.619c-.147-.035-14.752-3.587-21.245-13.127-9.954-14.624-16.861-40.064-16.93-40.319l-.614.165c.069.256,7,25.8,17.018,40.512C263.9,1469.5,278.739,1473.108,278.888,1473.143Z",
    transform: "translate(-240.246 -1419.078)",
    fill: "#1d1d1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2251",
    "data-name": "Grupo 2251",
    transform: "translate(109.091 85.18)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2244",
    "data-name": "Grupo 2244",
    transform: "translate(19.361)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2237",
    "data-name": "Grupo 2237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2236",
    "data-name": "Grupo 2236"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2235",
    "data-name": "Grupo 2235"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_979",
    "data-name": "Caminho 979",
    d: "M678.651,1439.115H625.816l-18.427,46.928h52.835Z",
    transform: "translate(-607.39 -1439.115)",
    fill: "#f94e67"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2240",
    "data-name": "Grupo 2240"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2239",
    "data-name": "Grupo 2239"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2238",
    "data-name": "Grupo 2238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_980",
    "data-name": "Caminho 980",
    d: "M607.39,1486.043h2.757l18.427-46.928h-2.757Z",
    transform: "translate(-607.39 -1439.115)",
    fill: "#f43d61"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2243",
    "data-name": "Grupo 2243",
    transform: "translate(36.392 18.829)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2242",
    "data-name": "Grupo 2242"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2241",
    "data-name": "Grupo 2241"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_981",
    "data-name": "Caminho 981",
    d: "M713.4,1496.936c-.732,2.156-.2,4.288,1.2,4.761s3.118-.89,3.851-3.045.2-4.288-1.2-4.761S714.135,1494.78,713.4,1496.936Z",
    transform: "translate(-713.075 -1493.796)",
    fill: "#e2f2f1"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2247",
    "data-name": "Grupo 2247",
    transform: "translate(0 43.138)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2246",
    "data-name": "Grupo 2246"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2245",
    "data-name": "Grupo 2245"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_982",
    "data-name": "Caminho 982",
    d: "M553.06,1564.391H572.8v3.79H553.06a1.9,1.9,0,0,1-1.895-1.895h0A1.9,1.9,0,0,1,553.06,1564.391Z",
    transform: "translate(-551.165 -1564.391)",
    fill: "#f43d61"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2250",
    "data-name": "Grupo 2250",
    transform: "translate(6.892 44.439)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2249",
    "data-name": "Grupo 2249",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2248",
    "data-name": "Grupo 2248"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_670",
    "data-name": "Ret\\xE2ngulo 670",
    width: 12.469,
    height: 0.594,
    transform: "translate(12.469 0.594) rotate(-180)",
    fill: "#f94e67"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2253",
    "data-name": "Grupo 2253",
    transform: "translate(66.837 62.644)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_983",
    "data-name": "Caminho 983",
    d: "M438.93,1423.461l.631-.084c-1.9-14.1-10.4-49.353-10.486-49.707l-.618.15C428.543,1374.173,437.039,1409.392,438.93,1423.461Z",
    transform: "translate(-428.457 -1373.669)",
    fill: "#1d1d1b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2254",
    "data-name": "Grupo 2254",
    transform: "translate(57.736 50.645)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_984",
    "data-name": "Caminho 984",
    d: "M432.186,1399.01l.613-.169c-.06-.218-6.032-21.9-8.674-29.475-2.006-5.751-6.027-16.219-10.412-21.71a30.634,30.634,0,0,0-11.46-8.835l-.229.593a29.974,29.974,0,0,1,11.192,8.638c4.326,5.417,8.315,15.811,10.308,21.523C426.159,1377.129,432.126,1398.792,432.186,1399.01Z",
    transform: "translate(-402.025 -1338.821)",
    fill: "#1d1d1b"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_985",
    "data-name": "Caminho 985",
    d: "M459.355,1622.276A29.656,29.656,0,0,1,430,1647.742H243.647a29.656,29.656,0,0,1-29.354-25.466Z",
    transform: "translate(-209.706 -1428.287)",
    fill: "#a2c7fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_671",
    "data-name": "Ret\\xE2ngulo 671",
    width: 254.237,
    height: 10.263,
    rx: 5.131,
    transform: "translate(254.237 193.989) rotate(-180)",
    fill: "#5295d8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2257",
    "data-name": "Grupo 2257",
    transform: "translate(530.206 792.838)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_986",
    "data-name": "Caminho 986",
    d: "M1413.022,1703.358a29.656,29.656,0,0,1-32.578,21.187l-184.583-25.626a29.657,29.657,0,0,1-25.574-29.26Z",
    transform: "translate(-1165.744 -1658.863)",
    fill: "#a2c7fc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_672",
    "data-name": "Ret\\xE2ngulo 672",
    width: 254.237,
    height: 10.263,
    rx: 5.131,
    transform: "translate(251.821 45.126) rotate(-172.096)",
    fill: "#5295d8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorImg);
export default __webpack_public_path__ + "static/media/error_img.eb5d18d1287c1d157cc8ab1cb9d05955.svg";
export { ForwardRef as ReactComponent };